if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');
        this.addOnform = this.closest('.shopify-section').querySelector('addon-product');
        if(this.addOnform){
          this.hasAddons = true;
        }

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';

      }

      getItems() {
        const formData = JSON.parse(serializeForm(this.form));
        let properties = this.getSelectedProperties(formData);

        // Always include the main item with updated properties for addons
        const mainItem = properties
          ? this.createItemWithProperties(formData, properties)
          : this.createItemFromForm(formData);

        if (this.hasAddons) {
          // Update properties of the main item with addon data
          this.addAddonProperties(mainItem);
        }

        if (this.hasMultiVariants) {
          console.log('hasMultiVariants');
          const items = this.addMultipleVariants();
          return { items };
        } else {

          return { items: [mainItem] };
        }

      }

      getSelectedProperties(formData) {
        if (formData.properties) {
          return Object.entries(formData.properties)
            .filter(([key, value]) => value) // Include only non-empty values
            .reduce((acc, [key, value]) => {
              acc[key] = value;
              return acc;
            }, {});
        }
        return {};
      }

      createItemWithProperties(formData, properties) {
        return {
          quantity: formData.quantity,
          id: formData.id,
          properties: {
            ...this.getSelectedProperties({ properties }),
          },
        };
      }

      createItemFromForm(formData) {
        return {
          quantity: formData.quantity,
          id: formData.id,
        };
      }

      addAddonProperties(mainItem) {
        const checkboxes = this.addOnform.querySelectorAll('input[type="checkbox"]:checked');
        if (checkboxes.length > 0) {
          if (!mainItem.properties) {
            mainItem.properties = {};
          }
          const addonValues = Array.from(checkboxes).map((checkbox) => checkbox.dataset.name);
          mainItem.properties['Zonder'] = addonValues.join(', ');
        }
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

        const items = this.getItems();
        const productFormData = this.getProductFormData(items);
        console.log(items);

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        config.body = JSON.stringify({
          ...productFormData,
          sections: this.cart.getSectionsToRender().map((section) => section.id),
          sections_url: window.location.pathname,
        });

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              if (response.status === 422 && this.dataset.continueSelling) {
                window.location = window.routes.cart_url;
                return;
              }
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          });
      }

      getProductFormData(items) {
        const lettersInput = this.form.querySelector('[name="properties[letters]"]');
        if (lettersInput && lettersInput.value) {
          const letters = lettersInput.value.split('');
          const productFormData = { items: [] };

          letters.forEach((letter, index) => {
            productFormData.items.push({
              id: this.form.querySelector('[name=id]').value,
              quantity: 1,
              properties: {
                _volgorde: index + 1,
                letter: letter,
              },
            });
          });

          return productFormData;
        }

        return items;
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }
    }
  );
}
